import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Check, Store, Save, ArrowRight, Info } from "lucide-react";
import { toast } from "sonner";
import { CATEGORIAS_DIGITALES, MKT_GOLD, MKT_TINT } from "../../lib/marketplace";

export default function CrearNegocio() {
  const navigate = useNavigate();
  const [seleccion, setSeleccion] = useState([]);

  const toggle = (id) =>
    setSeleccion((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  const continuar = () => {
    if (seleccion.length === 0) {
      toast.error("Selecciona al menos una categoría para continuar.");
      return;
    }
    // Solo UI: aún no se guardan datos reales.
    toast.success("¡Categorías seleccionadas! Completa los datos de tu tienda.");
    navigate("/marketplace/crear-tienda");
  };

  const guardarBorrador = () =>
    toast.success("Borrador guardado localmente (demostración visual).");

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="crear-negocio-page">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800"
          data-testid="cn-volver-top"
        >
          <ChevronLeft size={16} /> Volver
        </button>

        {/* Encabezado */}
        <div className="mt-5 flex items-center gap-4">
          <span
            className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm"
            style={{ backgroundColor: MKT_TINT, color: MKT_GOLD }}
          >
            <Store size={26} />
          </span>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: MKT_GOLD }}>
              ConstruLink Marketplace
            </p>
            <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
              Crea tu negocio digital
            </h1>
          </div>
        </div>
        <p className="mt-2 text-slate-600 max-w-2xl">
          Elige qué tipo de productos digitales deseas vender en ConstruLink Marketplace.
          Puedes seleccionar una o varias categorías.
        </p>

        {/* Grilla de categorías */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CATEGORIAS_DIGITALES.map((c) => {
            const activa = seleccion.includes(c.id);
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => toggle(c.id)}
                data-testid={`cn-cat-${c.id}`}
                aria-pressed={activa}
                className={[
                  "relative text-left rounded-2xl border bg-white p-5 transition-all duration-200 hover:-translate-y-0.5",
                  activa ? "shadow-lifted" : "border-slate-200 shadow-soft hover:border-slate-300",
                ].join(" ")}
                style={activa ? { borderColor: MKT_GOLD, boxShadow: `0 0 0 2px ${MKT_GOLD}33` } : undefined}
              >
                <span
                  className="absolute top-4 right-4 w-6 h-6 rounded-full flex items-center justify-center border transition-colors"
                  style={
                    activa
                      ? { backgroundColor: MKT_GOLD, borderColor: MKT_GOLD, color: "#fff" }
                      : { borderColor: "#CBD5E1", color: "transparent" }
                  }
                >
                  <Check size={14} />
                </span>
                <span
                  className="w-11 h-11 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: MKT_TINT, color: MKT_GOLD }}
                >
                  <c.Icon size={22} />
                </span>
                <h3 className="mt-3 text-[15px] font-bold text-slate-900">{c.label}</h3>
                <p className="mt-1 text-sm text-slate-500 leading-relaxed">{c.desc}</p>
              </button>
            );
          })}
        </div>

        {/* Nota UI */}
        <div className="mt-6 flex items-start gap-2 text-xs text-slate-500 bg-white border border-slate-200 rounded-xl p-3">
          <Info size={15} className="mt-0.5 flex-shrink-0" style={{ color: MKT_GOLD }} />
          Etapa de vista previa: por ahora esto es solo una experiencia visual. Todavía no se guardan datos reales.
        </div>

        {/* Acciones */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <button
            onClick={() => navigate(-1)}
            data-testid="cn-volver-btn"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border border-slate-300 text-slate-700 font-semibold hover:bg-slate-100 transition-colors"
          >
            <ChevronLeft size={16} /> Volver
          </button>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <button
              onClick={guardarBorrador}
              data-testid="cn-borrador-btn"
              className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border border-slate-300 text-slate-700 font-semibold hover:bg-slate-100 transition-colors"
            >
              <Save size={16} /> Guardar como borrador
            </button>
            <button
              onClick={continuar}
              data-testid="cn-continuar-btn"
              className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl text-white font-bold shadow-sm hover:brightness-110 transition-all"
              style={{ backgroundColor: MKT_GOLD }}
            >
              Continuar <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
